import React, { useState, useEffect } from 'react';
import './BlockingNotification.css';

interface BlockingNotificationProps {
  onDismiss: () => void;
}

export const BlockingNotification: React.FC<BlockingNotificationProps> = ({ onDismiss }) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleDismiss = () => {
    setIsVisible(false);
    onDismiss();
  };

  if (!isVisible) return null;

  return (
    <div className="blocking-notification">
      <div className="notification-content">
        <div className="notification-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
        </div>
        <div className="notification-text">
          <h4>Network Blocking Detected</h4>
          <p>
            Your browser or extensions are blocking Firebase requests. 
            Your data is being saved locally as a backup.
          </p>
          <div className="notification-actions">
            <button 
              className="notification-btn primary"
              onClick={() => window.open('https://vernikaai-production.web.app', '_blank')}
            >
              Try Incognito Mode
            </button>
            <button 
              className="notification-btn secondary"
              onClick={handleDismiss}
            >
              Dismiss
            </button>
          </div>
        </div>
        <button 
          className="notification-close"
          onClick={handleDismiss}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default BlockingNotification;
